import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Stack, MenuItem } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CVHttpService } from '../../services';

const months = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
];

function CertificateFormDialog({ open, onClose, onSave, cvId, certificate }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: certificate || {
            title: '',
            description: '',
            expiration_month: '',
            expiration_year: ''
        }
    });

    useEffect(() => {
        if (open) {
            if (certificate) {
                reset({
                    title: certificate.title || '',
                    description: certificate.description || '',
                    expiration_month: certificate.expiration_month || '',
                    expiration_year: certificate.expiration_year || ''
                });
            } else {
                reset({
                    title: '',
                    description: '',
                    expiration_month: '',
                    expiration_year: ''
                });
            }
        }
    }, [certificate, open, reset]);

    const onSubmit = async (data) => {
        try {
            const body = {
                ...data,
                id: certificate?.id || null,
                cv: cvId,
                expiration_month: data.expiration_month ? parseInt(data.expiration_month) : null,
                expiration_year: data.expiration_year ? parseInt(data.expiration_year) : null,
                user: null
            };
            await CVHttpService.saveCertificate(body);
            onSave();
        } catch (err) {
            alert('Failed to save certificate');
            console.error(err);
        }
    };

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 20 }, (_, i) => currentYear + i);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{certificate ? 'Edit Certificate' : 'Add Certificate'}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Certificate Name *"
                            {...register('title', { required: 'Certificate name is required' })}
                            error={!!errors.title}
                            helperText={errors.title?.message}
                        />
                        <TextField
                            fullWidth
                            label="Description"
                            multiline
                            rows={2}
                            {...register('description')}
                            placeholder="Describe the certificate, issuing organization, etc."
                        />
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Expiration Month (Optional)"
                                    {...register('expiration_month')}
                                    defaultValue={certificate?.expiration_month || ''}
                                >
                                    <MenuItem value="">No expiration</MenuItem>
                                    {months.map((month) => (
                                        <MenuItem key={month.value} value={month.value}>
                                            {month.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Expiration Year (Optional)"
                                    {...register('expiration_year')}
                                    defaultValue={certificate?.expiration_year || ''}
                                >
                                    <MenuItem value="">No expiration</MenuItem>
                                    {years.map((year) => (
                                        <MenuItem key={year} value={year}>
                                            {year}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default CertificateFormDialog;

